<template>
  <div class="picker">
    <div
      class="colorfield"
      :style="colorfield"
      @click="togglePicker"
    />
    <label>
      <slot />
    </label>
    <color-picker
      class="colorpicker"
      :value="color"
      @input="updateColor"
      v-if="showPicker"
      :preset-colors="presetColors"
    />
  </div>
</template>

<script>
import { Sketch } from 'vue-color'

export default {
  components: {
    colorPicker: Sketch
  },
  data () {
    return {
      showPicker: false
    }
  },
  props: {
    value: {
      type: String,
      default: '#fff'
    }
  },
  computed: {
    color () {
      return {
        hex: this.value
      }
    },
    colorfield () {
      return {
        'background-color': this.value
      }
    },
    presetColors () {
      return this.$store.getters.root.getters.presetColors
    }
  },
  methods: {
    togglePicker () {
      if (this.showPicker) {
        this.addColorToStore(this.color)
      }
      this.showPicker = !this.showPicker
    },
    updateColor (color) {
      this.$emit('input', color.hex8)
    },
    addColorToStore (color) {
      this.$store.getters.root.dispatch('addPresetColor', { color: color.hex })
    }
  },
  destroyed () {
    this.addColorToStore(this.color)
  },
  deactivated () {
    this.addColorToStore(this.color)
  }
}
</script>

<style lang="scss" scoped>
.picker {
  width: calc(16.667% - 2px);
  display: flex;
  margin-right: 2px;

  .colorfield {
    width: 100%;
    height: 64px;
    cursor: pointer;
    transition: all 150ms ease-in-out;

    &:hover {
      transform: scale(1.1) rotate(-3deg);
      box-shadow: 0 0 30px rgba($color: #000, $alpha: 0.5);
    }
  }

  label {
    display: none;
  }

  .colorpicker {
    position: absolute;
    margin-top: 70px;
    z-index: z(dropDownMenu);
  }
}
</style>
